import React from "react";
import { Link } from "wouter";
import { Menu } from "lucide-react";
import { useSideNav } from "../../../components/src/contexts/SideNavContext";

import { TicketNotification } from "../containers/TicketNotification";

export const Nav = ({ title, prod }: { title: string; prod: boolean }): React.ReactElement => {
    const { openSideNav } = useSideNav();

    return (
        <nav className="mb-5 w-full border-b border-white/10 bg-gradient-to-r from-sky-900 to-sky-800 text-white shadow-md">
            <div className="flex h-14 items-center justify-between px-3">
                <button
                    type="button"
                    aria-label="Open menu"
                    onClick={openSideNav}
                    className="inline-flex h-9 w-9 items-center justify-center rounded-md !border-0 bg-transparent p-0 text-white/90 transition-colors hover:bg-white/10 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
                >
                    <Menu className="h-5 w-5" />
                </button>
                <Link to="/" className="no-underline hover:no-underline">
                    <h1 className={`!mb-0 !text-sm !font-semibold uppercase tracking-[0.2em] ${prod ? "!text-white" : "!text-amber-300"}`}>
                        {title.toUpperCase()}
                    </h1>
                </Link>
                <TicketNotification />
            </div>
        </nav>
    );
};
